module.exports = __webpack_public_path__ + "img/ys-four-grid-select.72b2ea2f.png";